import { mailingConstants } from "./constants";
import axios from "../helpers/axios";

const normalizeEmails = (itemsEmails = []) => {
    if (!Array.isArray(itemsEmails)) return [];

    return itemsEmails
        .map((item) => {
            if (typeof item === "string") return item.trim();
            if (item?.email) return String(item.email).trim();

            return "";
        })
        .filter(Boolean);
};

const normalizeMailingPayload = (formMaterial = {}) => {
    return {
        senderKey: formMaterial.senderKey || "noreply",
        name: formMaterial.name || "",
        phone: formMaterial.phone || "",
        message: formMaterial.message || "",
        subject: formMaterial.subject || "Письмо от ALOTB",
        html: formMaterial.html || "",
        replyTo: formMaterial.replyTo || "",
        sendNow: !!formMaterial.sendNow,
        itemsEmails: normalizeEmails(formMaterial.itemsEmails),
    };
};

export const sendMailing = (formMaterial) => {
    return async (dispatch) => {
        dispatch({ type: mailingConstants.SEND_MAILING_REQUEST });

        try {
            const payload = normalizeMailingPayload(formMaterial);

            if (!payload.itemsEmails.length) {
                dispatch({
                    type: mailingConstants.SEND_MAILING_FAILURE,
                    payload: { message: "Список email пустой" }
                });

                return {
                    ok: false,
                    message: "Список email пустой"
                };
            }

            const res = await axios.post("/mailing/create", payload);

            if (res.status === 200 || res.status === 201) {
                dispatch({
                    type: mailingConstants.SEND_MAILING_SUCCESS,
                    payload: res.data
                });

                return {
                    ok: true,
                    data: res.data
                };
            }

            dispatch({
                type: mailingConstants.SEND_MAILING_FAILURE,
                payload: { message: "Ошибка отправки письма" }
            });

            return {
                ok: false,
                message: "Ошибка отправки письма"
            };
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "Ошибка отправки письма";

            dispatch({
                type: mailingConstants.SEND_MAILING_FAILURE,
                payload: { message }
            });

            return {
                ok: false,
                message
            };
        }
    };
};

export const createAndSendMailing = (formMaterial) => {
    return async (dispatch) => {
        dispatch({ type: mailingConstants.CREATE_AND_SEND_MAILING_REQUEST });

        try {
            const payload = {
                ...normalizeMailingPayload(formMaterial),
                sendNow: true,
            };

            if (!payload.itemsEmails.length) {
                dispatch({
                    type: mailingConstants.CREATE_AND_SEND_MAILING_FAILURE,
                    payload: { message: "Список email пустой" }
                });

                return {
                    ok: false,
                    message: "Список email пустой"
                };
            }

            const res = await axios.post("/mailing/createEmailingData", payload);

            if (res.status === 200 || res.status === 201) {
                dispatch({
                    type: mailingConstants.CREATE_AND_SEND_MAILING_SUCCESS,
                    payload: res.data
                });

                return {
                    ok: true,
                    data: res.data
                };
            }

            dispatch({
                type: mailingConstants.CREATE_AND_SEND_MAILING_FAILURE,
                payload: { message: "Ошибка сохранения и отправки рассылки" }
            });

            return {
                ok: false,
                message: "Ошибка сохранения и отправки рассылки"
            };
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "Ошибка сохранения и отправки рассылки";

            dispatch({
                type: mailingConstants.CREATE_AND_SEND_MAILING_FAILURE,
                payload: { message }
            });

            return {
                ok: false,
                message
            };
        }
    };
};

export const addMailing = (formMaterial) => {
    return async (dispatch) => {
        dispatch({ type: mailingConstants.ADD_MAILING_REQUEST });

        try {
            const payload = {
                ...normalizeMailingPayload(formMaterial),
                sendNow: false,
            };

            if (!payload.itemsEmails.length) {
                dispatch({
                    type: mailingConstants.ADD_MAILING_FAILURE,
                    payload: { message: "Список email пустой" }
                });

                return {
                    ok: false,
                    message: "Список email пустой"
                };
            }

            const res = await axios.post("/mailing/createEmailingData", payload);

            if (res.status === 200 || res.status === 201) {
                dispatch({
                    type: mailingConstants.ADD_MAILING_SUCCESS,
                    payload: res.data
                });

                return {
                    ok: true,
                    data: res.data
                };
            }

            dispatch({
                type: mailingConstants.ADD_MAILING_FAILURE,
                payload: { message: "Ошибка сохранения рассылки" }
            });

            return {
                ok: false,
                message: "Ошибка сохранения рассылки"
            };
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "Ошибка сохранения рассылки";

            dispatch({
                type: mailingConstants.ADD_MAILING_FAILURE,
                payload: { message }
            });

            return {
                ok: false,
                message
            };
        }
    };
};

export const getMailing = () => {
    return async (dispatch) => {
        dispatch({ type: mailingConstants.GET_MAILING_REQUEST });

        try {
            const res = await axios.get("/mailing/getEmailing");

            if (res.status === 200) {
                dispatch({
                    type: mailingConstants.GET_MAILING_SUCCESS,
                    payload: res.data
                });

                return {
                    ok: true,
                    data: res.data
                };
            }

            dispatch({
                type: mailingConstants.GET_MAILING_FAILURE,
                payload: { message: "Ошибка загрузки рассылок" }
            });

            return {
                ok: false,
                message: "Ошибка загрузки рассылок"
            };
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "Ошибка загрузки рассылок";

            dispatch({
                type: mailingConstants.GET_MAILING_FAILURE,
                payload: { message }
            });

            return {
                ok: false,
                message
            };
        }
    };
};

export const getByIdMailing = (id) => {
    return async (dispatch) => {
        dispatch({ type: mailingConstants.GET_BY_ID_MAILING_REQUEST });

        try {
            const res = await axios.get(`/mailing/getByIdEmailing/${id}`);

            if (res.status === 200) {
                dispatch({
                    type: mailingConstants.GET_BY_ID_MAILING_SUCCESS,
                    payload: res.data
                });

                return {
                    ok: true,
                    data: res.data
                };
            }

            dispatch({
                type: mailingConstants.GET_BY_ID_MAILING_FAILURE,
                payload: { message: "Ошибка загрузки рассылки" }
            });

            return {
                ok: false,
                message: "Ошибка загрузки рассылки"
            };
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "Ошибка загрузки рассылки";

            dispatch({
                type: mailingConstants.GET_BY_ID_MAILING_FAILURE,
                payload: { message }
            });

            return {
                ok: false,
                message
            };
        }
    };
};

export const clearMailingStatus = () => ({
    type: mailingConstants.CLEAR_MAILING_STATUS
});